import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import { useSettingsStore } from '@/store/settingsStore';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { validatePhoneNumber } from '@/utils/validation';

export function WhatsAppSettings() {
  const { settings, isLoading, error, updateSettings } = useSettingsStore();
  const [number, setNumber] = useState(settings.whatsappNumber);
  const [message, setMessage] = useState(settings.whatsappMessage);
  const [validationError, setValidationError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const phoneValidation = validatePhoneNumber(number);
    if (phoneValidation !== true) {
      setValidationError(phoneValidation);
      return;
    }

    await updateSettings({
      whatsappNumber: number,
      whatsappMessage: message
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 bg-white p-6 rounded-lg shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <MessageCircle className="h-5 w-5 text-[#25D366]" />
        <h3 className="text-lg font-semibold">إعدادات واتساب</h3>
      </div>

      <div className="space-y-2">
        <Label htmlFor="whatsappNumber">رقم الواتساب</Label>
        <Input
          id="whatsappNumber"
          value={number}
          onChange={(e) => {
            setNumber(e.target.value);
            setValidationError('');
          }}
          placeholder="05xxxxxxxx"
          dir="ltr"
          className="text-left"
        />
        {validationError && <p className="text-sm text-red-500">{validationError}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="whatsappMessage">الرسالة الافتراضية</Label>
        <Input
          id="whatsappMessage"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="أدخل الرسالة الافتراضية"
        />
      </div>

      {error && (
        <p className="text-sm text-red-500">{error}</p>
      )}

      <Button 
        type="submit" 
        className="bg-[#25D366] hover:bg-[#128C7E]"
        disabled={isLoading}
      >
        <MessageCircle className="h-4 w-4 ml-2" />
        {isLoading ? 'جاري الحفظ...' : 'حفظ الإعدادات'}
      </Button>
    </form>
  );
}